import { Button, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { Mode } from '../services/ranking';
import styled from '../styled';

const SectionTitle = styled('h2')`
  font-size: 16px;
  color: ${(p) => p.theme.palette.primary.main};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;

  @media (max-width: 800px) {
    text-align: center;
  }
`;

const SectionTitleWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(p) => p.theme.spacing(2)}px;

  @media (max-width: 800px) {
    display: block;
  }
`;

export const ControlsContainer = styled('div')((p) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',

  '@media (max-width: 800px)': {
    justifyContent: 'center'
  },
  '> :not(:first-child)': {
    marginLeft: p.theme.spacing(2)
  }
}));

export const ControlButton = styled(Button)<{ selected: boolean }>`
  font-size: 16px;
  ${(p) => (p.selected ? `color: ${p.theme.palette.primary.main};` : '')}
  ${(p) =>
    p.selected
      ? `&:before { content: ''; width: 100%; bottom: 4px; position: absolute; border-bottom: 1px solid ${p.theme.palette.primary.main}; }`
      : ''}
`;

const SCORE_RANGES = [2, 7, 30];

const Controls = ({
  scoreRange,
  setScoreRange,
  mode,
  setMode
}: {
  scoreRange: number;
  setScoreRange: (nextScoreRange: number) => void;
  mode: Mode;
  setMode: (nextMode: Mode) => void;
}) => {
  return (
    <ControlsContainer>
      <ControlButton selected={mode === 'all'} onClick={() => setMode('all')}>
        Trending now
      </ControlButton>
      <ControlButton selected={mode === 'new'} onClick={() => setMode('new')}>
        New
      </ControlButton>
      <Select
        value={`${scoreRange}`}
        onChange={(ev) =>
          setScoreRange(parseInt(ev.target.value! as string, 10))
        }
      >
        {SCORE_RANGES.map((r) => (
          <MenuItem key={r} value={`${r}`}>
            Last {r} days
          </MenuItem>
        ))}
      </Select>
    </ControlsContainer>
  );
};

export const RankingPageHeader = ({
  title,
  scoreRange,
  setScoreRange,
  mode,
  setMode
}: {
  title?: React.ReactNode;
  scoreRange: number;
  setScoreRange: (nextScoreRange: number) => void;
  mode: Mode;
  setMode: (nextMode: Mode) => void;
}) => {
  return (
    <SectionTitleWrapper>
      {title ? <SectionTitle>{title}</SectionTitle> : <div />}
      <Controls
        scoreRange={scoreRange}
        setScoreRange={setScoreRange}
        mode={mode}
        setMode={setMode}
      />
    </SectionTitleWrapper>
  );
};
